// ContractBasis API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

type ContractBasisRequests = {
    domainName: string,
    create: RequestConfigFunction,
    update: RequestConfigFunction<{ id: number }>,
    editableData: RequestConfigFunction<{ id: number }>,
    get: RequestConfigFunction<{ id: number }>,
    archive: RequestConfigFunction<{ id: number }>,
    restore: RequestConfigFunction<{ id: number }>,
    modifications: RequestConfigFunction<{ id: number }>,
    handoverData: RequestConfigFunction<{ data: any }>,
    getAllProductTypes: RequestConfigFunction<undefined>,
    cancellation: RequestConfigFunction<{ id: number }>,
    validity: RequestConfigFunction<{ id: number }>,
    filterRequest: RequestConfigFunction<{ params: any, includeFilters: Record<string, any> }>,
    customerQuotation: RequestConfigFunction<undefined>,
    createAdditionalFees: RequestConfigFunction<{ contractId: number }>,
    filterRequestAdditionalFees: RequestConfigFunction<{ contractId: number, params: any }>,
    filterRequestLaneGroups: RequestConfigFunction<{
        contractId: number, quoteId?: number, params?: any
    }>,
    filterCountLaneGroups: RequestConfigFunction<{ contractId: number }>,
    createLaneGroup: RequestConfigFunction<{ contractId: number }>,
    customerExecutionAll: RequestConfigFunction<{ id: number, params: any }>,
    hasValidAdditionalFees: RequestConfigFunction<{ id: number }>,
    createLongTermLeaseFees: RequestConfigFunction<{ contractId: number }>,
    filterRequestLongTermLeaseFees: RequestConfigFunction<{
        contractId: number, params: Record<string, any>
    }>,
}

const contractBasisRequests: ContractBasisRequests = {
    domainName: 'ContractBasis',
    create: () => {
        return {
            url: 'contractbasis',
            method: 'POST',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `contractbasis/${id}/data`,
            method: 'PATCH',
        }
    },
    editableData: ({
        id,
    }) => {
        return {
            url: `contractbasis/${id}/editable-data`,
            method: 'PATCH',
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `contractbasis/${id}`,
            method: 'GET',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `contractbasis/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `contractbasis/${id}/restore`,
            method: 'PATCH',
        }
    },
    modifications: ({
        id,
    }) => {
        return {
            url: `contractbasis/${id}/modifications`,
            method: 'GET',
        }
    },
    handoverData: ({
        data,
    }) => {
        return {
            url: `contractbasis/${data.id}/handover-data`,
            method: 'PATCH',
            data,
        }
    },
    getAllProductTypes: () => {
        return {
            url: 'contractbasis/producttype/all',
            method: 'GET',
        }
    },
    cancellation: ({
        id,
    }) => {
        return {
            url: `contractbasis/${id}/cancellation`,
            method: 'PATCH',
        }
    },
    validity: ({
        id,
    }) => {
        return {
            url: `contractbasis/${id}/validity`,
            method: 'PATCH',
        }
    },
    filterRequest: ({
        params,
        includeFilters,
    }) => {
        return {
            url: 'contractbasis/filter-request/all',
            method: 'POST',
            ...params,
            includeFilters,
        }
    },
    customerQuotation: () => {
        return {
            url: 'contractbasis/customerquotation/filter-request/all',
            method: 'POST',
        }
    },
    createAdditionalFees: ({
        contractId,
    }) => {
        return {
            url: `contractbasis/${contractId}/additionalfees`,
            method: 'POST',
        }
    },
    createLongTermLeaseFees: ({
        contractId,
    }) => {
        return {
            url: `contractbasis/${contractId}/longtermleasefees`,
            method: 'POST',
        }
    },
    filterRequestAdditionalFees: ({
        contractId,
        params,
    }) => {
        return {
            url: `contractbasis/${contractId}/additionalfees/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    filterRequestLongTermLeaseFees: ({
        contractId,
        params,
    }) => {
        return {
            url: `contractbasis/${contractId}/longtermleasefees/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    filterRequestLaneGroups: ({
        contractId,
        quoteId,
        params,
    }) => {
        return {
            url: `contractbasis/${contractId}/lanegroup/filter-request/all`,
            method: 'POST',
            data: {
                quoteId,
            },
            ...params,
        }
    },
    filterCountLaneGroups: ({
        contractId,
    }) => {
        return {
            url: `contractbasis/${contractId}/lanegroup/filter-request/all`,
            method: 'POST', // Not used, LaneGroupsTable uses the URL only
        }
    },
    createLaneGroup: ({
        contractId,
    }) => {
        return {
            url: `contractbasis/${contractId}/lanegroup`,
            method: 'POST',
        }
    },
    customerExecutionAll: ({
        id,
        params,
    }) => {
        return {
            url: `contractbasis/${id}/customerexecution/all`,
            method: 'GET',
            ...params,
        }
    },
    hasValidAdditionalFees: ({
        id,
    }) => {
        return {
            url: `contractbasis/${id}/has-valid-additional-fees`,
            method: 'GET',
        }
    },
}

export default contractBasisRequests

export const laneGroupSelectorConversion = (laneGroups) => {
    return laneGroups.map(({
        id,
        laneGroupNumber,
    }) => {
        return {
            value: id,
            label: laneGroupNumber,
            id,
        }
    })
}
